module["exports"] = [];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/name/prefix.js
// module id = 2409
// module chunks = 2